webix.protoUI({
	name: "ssheet-bar-title",
	defaults:{
		borderless: true
	},
	$init: function(){
		this.$view.className += " webix_ssheet_subbar_title";
	}
},webix.ui.template);